
import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";
import { secureLog } from "@/utils/securityUtils";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-uplivion-blue"></div>
      </div>
    );
  }

  if (!user) {
    secureLog.warn('Unauthorized access attempt, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
